import DataResume from "@/services/DataResume";
import { Procedure } from "@/types";
// import UserLogin from "@/utility/User";


import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

export interface ProcedureState {
  procedure: Procedure[]
}

@Module({ store, dynamic: true, name: "storeProcedure" })
class ProcedureStore extends VuexModule implements ProcedureState {
  procedure: Procedure[] = [];

  @Mutation SET_PROCEDURE(procedure: Procedure[]) {
    this.procedure = procedure;
  }

  @Action act_procedure_all(term: string) {
    // console.log('term',term)
    const dt = DataResume.getDataProcedure(term);
    dt.then(dt => {
      const tindakan = dt
      // const status = dt.status
      this.SET_PROCEDURE(tindakan);
    });

  }


}

export const storeProcedure = getModule(ProcedureStore);
